import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const Cancel = () => {
  return (
    <div className="min-h-screen bg-surface flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full bg-white rounded-sm border border-border p-8 text-center">
        <XCircle className="w-16 h-16 text-destructive mx-auto mb-4" />
        <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: 'IBM Plex Sans' }}>
          Paiement annulé
        </h2>
        <p className="text-muted-foreground mb-6">
          Votre paiement a été annulé. Vous pouvez réessayer quand vous voulez.
        </p>
        <div className="space-y-3">
          <Link
            to="/cart"
            className="block w-full btn-primary py-3 rounded-sm font-semibold"
            data-testid="back-to-cart-link"
          >
            Retour au panier
          </Link>
          <Link
            to="/products"
            className="block w-full btn-secondary py-3 rounded-sm font-semibold"
            data-testid="continue-shopping-link"
          >
            Continuer mes achats
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cancel;